// Default theme uses `Aubergine` colour palette
const defaultTheme = {
  name: 'defaultTheme',
  color: {
    headerAvatarHover: 'rgba(154, 134, 155, 0.35)',
    headerBackground: '#350D36',
    headerSearch: '#684A68',
    headerSearchBackground: '#431E44',
    headerSearchHover: '#9A869B',
    headerText: '#FFFFFF',
    sidebarBackground: '#3F0E40',
    sidebarDivider: '#522653',
    sidebarHeaderBackground: '#3F0E40',
    sidebarHeaderIcon: '#3F0E40',
    sidebarHeaderIconBackground: '#FFFFFF',
    sidebarHeaderText: '#FFFFFF',
    sidebarHover: '#350D36',
    sidebarText: '#CFC3CF',
    chatBackground: '#FFFFFF',
    chatDivider: '#DDDDDD',
    chatHeader: '#000000',
    chatMessageHover: '#F7F7F7',
    chatText: '#000000',
    chatTextArea: '#FFFFFF',
    chatTextAreaBorder: '#000000',
    chatFormattingBarBackground: '#f8f8f8',
    chatFormattingBarBorder: '#DDDDDD',
    chatFormattingBarIcon: '#555555',
    presenceActive: '#2BAC76',
    presenceAway: '#CFC3CF',
    badge: '#CD2553',
  },
};

export default defaultTheme;
